import {setErrors, setErrorsList, removeErrorsFromList} from '@store/slices/common';
import {triggerTokenExpired} from '@utils/tokenExpiryHandler';

export const errorsRequestHandler = (request, storeInstance) => {
  // Пропускаем обработку ошибок для запросов обновления токена
  if (request._isRefreshRequest) return request;

  const errorsList = storeInstance.getState().common.errors_list;
  if (request.data instanceof FormData) {
    // Получаем имена полей из FormData
    let names = [];
    for (let [key] of request.data.entries()) {
      names.push(key);
    }

    if (names.length && errorsList.length) {
      storeInstance.dispatch(removeErrorsFromList({names}));
    }
  }
  return request;
};

export const errorsResponseHandler = (response, storeInstance) => {
  if (response.config?._isRefreshRequest) {
    return response;
  }

  if (response.config?.skipErrorHandler) {
    return response;
  }

  if (response.data?.detail) {
    if (Array.isArray(response.data.detail)) {
      storeInstance.dispatch(
        setErrorsList({
          errors_list: response.data?.errors_list,
        }),
      );
    } else {
      if (response?.status === 401) {
        triggerTokenExpired();
      } else {
        storeInstance.dispatch(
          setErrors({
            error: response.data?.detail,
          }),
        );
      }
    }
  }
  return response;
};

export const errorsRejectHandler = async (error, storeInstance) => {
  if (error.config?._isRefreshRequest) {
    return Promise.reject(error);
  }

  // check no internet
  console.log('error reject', error.response?.data);
  if (error.response?.data?.detail) {
    console.log('details', error.response.data.detail);
    if (Array.isArray(error.response.data.detail)) {
      storeInstance.dispatch(
        setErrorsList({
          errors_list: error.response.data?.detail,
        }),
      );
    } else {
      if (error.response?.status === 401) {
        triggerTokenExpired();
      } else {
        storeInstance.dispatch(
          setErrors({
            error: error.response.data?.detail,
          }),
        );
      }
    }
  }
  return Promise.reject(error);
};
